import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { channelType } from 'shared/consts';
import { v4 as uuidv4 } from 'uuid';

import './index.scss';

interface IProps {
  hideCard?: boolean;
}

const SkeletonProductInfo: FC<IProps> = ({ hideCard }) => {
  const renderSkeletonColumn = (rows: number, height: number, top: number, name: string) => (
    <div className="skeleton__productinfo__column">
      {[...Array(rows)].map(() => (
        <div style={{ marginTop: top }} className={`skeleton__productinfo__item__${name}`} key={uuidv4()}>
          <Skeleton height={height} />
        </div>
      ))}
    </div>
  );
  return (
    <div className={`skeleton__productinfo skeleton__productinfo__${channelType}`}>
      {renderSkeletonColumn(2, 60, 15, 'info')}
      {!hideCard && renderSkeletonColumn(1, 280, 0, 'card')}
    </div>
  );
};

export default SkeletonProductInfo;
